import React, { useEffect, useState } from "react";
import "./index.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Formik, Form as FormikForm } from "formik";
import { toast } from "react-toastify";
import axios from "../../axios";
import { API_CALL_URL_PRIVATE, DOMAIN_URL } from "../../constants/compensate";
import Texterror from "../Texterror";
import {
  payPeriodValidation,
  portalUserValidation,
} from "../../utils/validator";
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import CROSS from "../../../src/assets/img/close.png";
import { setLoadingPage } from "../../store/actions";

function EditPayPeriodForm() {
  const dispatch = useDispatch();
  const { ID } = useParams();
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const loading_page = useSelector((state) => state.compensate.LoadingPage);
  console.log(customer_code, "customercode");
  const navigate = useNavigate();
  const [FormInitialData, setFormInitialData] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [initialImageUrl, setInitialImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [costCenterMaster, setCostCenterMaster] = useState(null);
  const [costCenterData, setCostCenterData] = useState(null);
  const [costCenterFilteredData, setCostCenterFilteredData] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [facilityMaster, setFacilityMaster] = useState(null);
  const [applications, setApplications] = useState(null);
  const [selectAllApplication, setSelectAllApplication] = useState(false);
  const [DeselectAllApplication, setDeselectAllApplication] = useState(false);
  const [selectAllCostCenter, setSelectAllCostCenter] = useState(false);
  const [DeselectAllCostCenter, setDeselectAllCostCenter] = useState(false);
  const [beginDate, setBeginDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isInitialData, setISInitialData] = useState(false);
  const [dropUserType, setDropUserType] = useState(null);
  const currentYear = new Date().getFullYear();
  // const years = Array.from({ length: 4 }, (_, index) => currentYear + index);
  const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026];
  console.log("date", beginDate, endDate);

  const [initialValues, setInitialValues] = useState({
    name: "",
    fiscal_year_name: "",
    pay_period_hours: "",
    pay_period_sequence: "",
    begin_date: "",
    end_date: "",
    fy_sequence: "",
    fiscal_year: currentYear.toString(),
    calendar_year: currentYear.toString(),
  });

  //   const getFormatDateList = (val) => {
  //     const inputDate = new Date(`${val}`);
  //     const year = inputDate.getFullYear();
  //     const month = String(inputDate.getMonth() + 1).padStart(2, "0");
  //     const day = String(inputDate.getDate()).padStart(2, "0");
  //     return val ? `${day}/${month}/${year}` : "";
  //   };

  const getFormatDate = (val) => {
    if (!val) return ""; // Handle empty or undefined input
    let inputDate;
    if (typeof val === "string") {
      // If the input is a string, attempt to parse it
      const dateComponents = val.split("/");
      if (dateComponents.length !== 3) return ""; // Handle invalid date format

      const [month, day, year] = dateComponents.map((component) =>
        parseInt(component, 10)
      );

      // Check if the parsed components are valid numbers
      if (isNaN(month) || isNaN(day) || isNaN(year)) {
        return ""; // Handle invalid numeric values
      }

      inputDate = new Date(year, month - 1, day); // Note: months are zero-based in JavaScript dates
    } else if (val instanceof Date) {
      // If the input is a Date object, use it directly
      inputDate = val;
    } else {
      return ""; // Handle unsupported input type
    }

    const formattedYear = inputDate.getFullYear();
    const formattedMonth = String(inputDate.getMonth() + 1).padStart(2, "0");
    const formattedDay = String(inputDate.getDate()).padStart(2, "0");

    return `${formattedDay}-${formattedMonth}-${formattedYear}`;
  };

  //   useEffect(() => {
  //     const getSequenceData = async () => {
  //       const resp = await axios.post(
  //         `${API_CALL_URL_PRIVATE}/payperiod/nextData`,
  //         {
  //           customer_code: parseInt(customer_code),
  //         }
  //       );
  //       console.log(resp);
  //       const Detail = resp?.data?.data?.next_data;
  //       setInitialValues((prev) => {
  //         return {
  //           ...prev,
  //           name: Detail?.name,
  //           fy_sequence: Detail?.fy_sequence,
  //           pay_period_sequence: Detail?.pay_period_sequence,
  //         };
  //       });
  //     };
  //     getSequenceData();
  //   }, []);

  // const performSearch = (data, query) => {
  //   if (query.trim() === "") {
  //     return data || [];
  //   } else {
  //     return (data || []).filter((e) =>
  //       e.cost_center_name.toLowerCase().includes(query.toLowerCase())
  //     );
  //   }
  // };

  useEffect(() => {
    const getInitialData = async () => {
      const resp = await axios.post(`${API_CALL_URL_PRIVATE}/payperiod/view`, {
        _id: ID,
      });
      console.log(resp);
      const Detail = resp?.data?.data?.payperiod;
      setInitialValues((prev) => {
        return {
          ...prev,
          name: Detail?.name,
          fiscal_year_name: Detail?.fiscal_year_name,
          pay_period_hours: Detail?.pay_period_hours,
          pay_period_sequence: Detail?.pay_period_sequence,
          begin_date: Detail?.begin_date,
          end_date: Detail?.end_date,
          fy_sequence: Detail?.fy_sequence,
          fiscal_year: Detail?.fiscal_year,
          calendar_year: Detail?.calendar_year,
        };
      });
      const hdateArray = Detail?.begin_date?.split("-");
      if (hdateArray && hdateArray.length === 3) {
        const [hday, hmonth, hyear] = hdateArray;

        // Check if day, month, and year are valid numbers
        if (!isNaN(hday) && !isNaN(hmonth) && !isNaN(hyear)) {
          // const utcDate = new Date(Date.UTC(hyear, hmonth - 1, hday));
          // setBeginDate(new Date(`${hyear}-${hmonth}-${hday}`));
          setBeginDate(new Date(hyear, hmonth - 1, hday));

          console.log(new Date(hyear, hmonth - 1, hday), "begin date");
        }
        // if (!isNaN(hday) && !isNaN(hmonth) && !isNaN(hyear)) {

        //   setBeginDate(new Date(Date.UTC(hyear, hmonth - 1, hday)));
        // }
      }

      const tdateArray = Detail?.end_date?.split("-");
      if (tdateArray && tdateArray.length === 3) {
        const [day, month, year] = tdateArray;

        // Check if day, month, and year are valid numbers
        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          // setEndDate(new Date(`${year}-${month}-${day}`));
          setEndDate(new Date(year, month - 1, day));
        }
        // if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        //   setEndDate(new Date(Date.UTC(year, month - 1, day)));
        // }
      }
      setISInitialData(true);
    };
    getInitialData();
  }, []);

  const performSearch = (data, query) => {
    if (query.trim() === "") {
      return data || [];
    } else {
      return data.filter(
        (e) =>
          e.cost_center_name.toLowerCase().includes(query.toLowerCase()) ||
          e.cost_center_number.toString().includes(query.toLowerCase())
      );
    }
  };

  const onSubmit = (values, onSubmittingProps) => {
    console.log("form Values", values);
    formSubmit(values);
  };
  const formSubmit = async (values) => {
    const obj = {
      _id: ID,
      customer_code: customer_code,
      name: values.name,
      fiscal_year_name: values.fiscal_year_name,
      pay_period_hours: values.pay_period_hours,
      pay_period_sequence: values.pay_period_sequence,
      begin_date: getFormatDate(beginDate),
      end_date: getFormatDate(endDate),
      fy_sequence: values.fy_sequence,
      fiscal_year: values.fiscal_year,
      calendar_year: values.calendar_year,
    };
    try {
      setIsLoading(true);
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/payperiod/create`,
        obj
      );
      console.log(resp);
      toast.success(resp?.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      // navigate("/admin/customer");
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  function formatNumberWithCommas(number) {
    return number.toLocaleString("en-US"); // Force using US locale
  }

  return (
    <>
      {isInitialData && !loading_page ? (
        <>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={payPeriodValidation}
            enableReinitialize
            validateOnChange
          >
            {(formik) => (
              <div className="main-panel">
                {console.log(formik)}
                <div className="content-wrapper">
                  <div className="page-header">
                    <h3 className="page-title">
                      <a href="#" className="badge badge-dark"></a>
                    </h3>
                    <div className></div>
                  </div>
                  <div className="row">
                    <div class="col-12 grid-margin stretch-card">
                      <div class="card">
                        <FormikForm className="forms-sample">
                          <div class="card-body">
                            <div className="row align-items-center">
                              <div className="col-3">
                                <Link
                                  to={`/admin/pay-periods`}
                                  className="f-14 white-text-dark-mode"
                                >
                                  <FontAwesomeIcon icon="fa-solid fa-arrow-left " />{" "}
                                  Back
                                </Link>
                              </div>
                              <div className="col-6">
                                <h4 class="card-title text-center">
                                  Edit Pay Period
                                </h4>
                              </div>
                              <div className="col-3 text-end">
                                <Button
                                  className="ms-3"
                                  variant="success"
                                  type="submit"
                                  disabled={isLoading}
                                >
                                  {isLoading ? "Saving..." : "Save"}
                                </Button>
                              </div>
                            </div>

                            <div class="row">
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_code"
                              >
                                <Form.Label>Calender Year Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder=""
                                  name="name"
                                  value={formik.values.name}
                                  {...formik.getFieldProps("name")}
                                />
                                <ErrorMessage
                                  name="name"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_number"
                              >
                                <Form.Label>Calender Year Sequence</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder=""
                                  name="pay_period_sequence"
                                  value={formik.values.pay_period_sequence}
                                  {...formik.getFieldProps(
                                    "pay_period_sequence"
                                  )}
                                />
                                <ErrorMessage
                                  name="pay_period_sequence"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_code"
                              >
                                <Form.Label>Fiscal Year Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder=""
                                  name="fiscal_year_name"
                                  value={formik.values.fiscal_year_name}
                                  {...formik.getFieldProps("fiscal_year_name")}
                                />
                                <ErrorMessage
                                  name="fiscal_year_name"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_number"
                              >
                                <Form.Label>FY Sequence</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder=""
                                  name="fy_sequence"
                                  value={formik.values.fy_sequence}
                                  {...formik.getFieldProps("fy_sequence")}
                                />
                                <ErrorMessage
                                  name="fy_sequence"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_email"
                              >
                                <Form.Label>Begin Date</Form.Label>
                                <div>
                                  <ReactDatePicker
                                    closeOnScroll={(e) => e.target === document}
                                    selected={beginDate}
                                    dateFormat="MM/dd/yyyy"
                                    onChange={(date) => {
                                      formik.setFieldTouched(
                                        "begin_date",
                                        true,
                                        true
                                      );
                                      formik.setFieldValue("begin_date", date);
                                      setBeginDate(date);
                                    }}
                                    onBlur={() => {
                                      formik.setFieldTouched(
                                        "begin_date",
                                        true,
                                        true
                                      );
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  name="begin_date"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_email"
                              >
                                <Form.Label>End Date</Form.Label>
                                <div>
                                  <ReactDatePicker
                                    closeOnScroll={(e) => e.target === document}
                                    selected={endDate}
                                    dateFormat="MM/dd/yyyy"
                                    // minDate={new Date()}
                                    onChange={(date) => {
                                      formik.setFieldTouched(
                                        "end_date",
                                        true,
                                        true
                                      );
                                      formik.setFieldValue("end_date", date);
                                      setEndDate(date);
                                    }}
                                    onBlur={() => {
                                      formik.setFieldTouched(
                                        "end_date",
                                        true,
                                        true
                                      );
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  name="end_date"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_email"
                              >
                                <Form.Label>Calendar Year</Form.Label>
                                <Form.Select
                                  aria-label="Default select example"
                                  className="white"
                                  name="calendar_year"
                                  value={`${formik.values.calendar_year}`}
                                  onChange={(e) => {
                                    // formik.setFieldTouched(
                                    //   "customer_status",
                                    //   true,
                                    //   true
                                    // );
                                    formik.setFieldValue(
                                      "calendar_year",
                                      e.target.value
                                    );
                                    console.log(e.target.value);
                                  }}
                                  // onChange={formik.handleChange}
                                >
                                  {years.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </Form.Select>
                                <ErrorMessage
                                  name="calender_year"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_email"
                              >
                                <Form.Label>Fiscal Year</Form.Label>
                                <Form.Select
                                  aria-label="Default select example"
                                  className="white"
                                  name="fiscal_year"
                                  value={`${formik.values.fiscal_year}`}
                                  onChange={(e) => {
                                    // formik.setFieldTouched(
                                    //   "customer_status",
                                    //   true,
                                    //   true
                                    // );
                                    formik.setFieldValue(
                                      "fiscal_year",
                                      e.target.value
                                    );
                                    console.log(e.target.value);
                                  }}
                                  // onChange={formik.handleChange}
                                >
                                  {years.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </Form.Select>
                                <ErrorMessage
                                  name="fiscal_year"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group
                                className="col-md-3 mb-3"
                                controlId="exampleForm.c_name"
                              >
                                <Form.Label>Pay Period Hours</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder=""
                                  name="pay_period_hours"
                                  {...formik.getFieldProps("pay_period_hours")}
                                />
                                <ErrorMessage
                                  name="pay_period_hours"
                                  component={Texterror}
                                />
                              </Form.Group>
                              <Form.Group className="col-md-12 mb-3 d-flex justify-content-end">
                                {/* <Button variant="primary" type="submit">
                              Reset
                            </Button> */}
                                <Button
                                  className="ms-3"
                                  variant="success"
                                  type="submit"
                                  disabled={isLoading}
                                >
                                  {isLoading ? "Saving..." : "Save"}
                                </Button>
                              </Form.Group>
                            </div>
                          </div>
                        </FormikForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Formik>
        </>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100vw h-100vh">
          <span class="loader" style={{ width: "50px", height: "50px" }}></span>
        </div>
      )}
    </>
  );
}

export default EditPayPeriodForm;
